import Component from '@bythepixel/component-loader';
import Tabs from '@Core/components/tabs';
import { fadeOut, fadeIn } from '@Core/utility';
import { Events } from './events';

export default class SectionTabs extends Component {
  static selector = '[data-comp-tabs]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);

    const tabContainer = this.$container;
    const tabContent = 'data-tab-content';
    const tabButton = 'data-tab-button';

    this.tabListWrapper = this.$container.querySelector(
      '.section-tabs__tab-list-wrapper',
    );

    this.sectionTabs = new Tabs(tabContainer, {
      queryParamState: true,
      onSelect: (activeTab, inactiveTabs) => {
        inactiveTabs.forEach((tab) => {
          const tabsToFade = tabContainer.querySelector(
            `[${tabContent}="${tab.getAttribute(tabButton)}"]`,
          );

          if (!tabsToFade) {
            return;
          }

          fadeOut(tabsToFade, {
            done() {
              const tabSelector = `[${tabContent}="${activeTab.getAttribute(tabButton)}"]`;
              const activatedTab = tabContainer.querySelector(tabSelector);
              fadeIn(activatedTab, {
                done() {
                  window.dispatchEvent(Events.TabUpdated(activatedTab));
                },
              });
            },
          });
        });

        this.scrollToTab(activeTab);
      },
    });
  }

  /**
   * Horizontally scrolls the tab container to bring the tab
   * into view
   *
   * @param { HTMLElement } tab
   */
  scrollToTab(tab) {
    this.tabListWrapper.scrollTo({
      left: tab.offsetLeft,
      behavior: 'smooth',
    });
  }
}
